export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: any }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Time: any;
};

export type AcceptedTermOfUse = {
  __typename?: 'AcceptedTermOfUse';
  id: Scalars['Int'];
  date: Scalars['Time'];
};

export type Account = {
  __typename?: 'Account';
  type: Scalars['String'];
  number: Scalars['String'];
};

export type AccountBalance = {
  __typename?: 'AccountBalance';
  balance: Scalars['Float'];
  investable: Scalars['Float'];
  daytrade_limit: Scalars['Float'];
};

export type Address = {
  __typename?: 'Address';
  country: Scalars['String'];
  city: Scalars['String'];
  zip_code: Scalars['String'];
  address: Scalars['String'];
};

export type AuthFirst = {
  uid: Scalars['String'];
  password: Scalars['String'];
};

export type AuthSecond = {
  first_token: Scalars['String'];
  secret: Scalars['String'];
};

export type AuthToken = {
  __typename?: 'AuthToken';
  need_password_update: Scalars['Boolean'];
  expiry: Scalars['Int'];
  language: Scalars['String'];
  terms_of_use?: Maybe<TermsOfUse>;
};

export type Broker = {
  __typename?: 'Broker';
  name: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['String'];
  img: Scalars['String'];
};

export type CreateExchangeOrder = {
  direction: Direction;
  account: Scalars['String'];
  security: Scalars['String'];
  count: Scalars['Int'];
  daytrade: Scalars['Boolean'];
  daytrade_type?: Maybe<DaytradeType>;
  type: ExchangeRateType;
  limit_price?: Maybe<Scalars['Float']>;
  activation_price?: Maybe<Scalars['Float']>;
  outside_trading_hours: Scalars['Boolean'];
  validity_start: Scalars['Time'];
  validity_end?: Maybe<Scalars['Time']>;
  edited_id?: Maybe<Scalars['Int']>;
};

export type Currency = {
  __typename?: 'Currency';
  currency: Scalars['String'];
  name: Scalars['String'];
  decimal: Scalars['Int'];
};

export type CurrencyConversion = {
  __typename?: 'CurrencyConversion';
  transaction_code: Scalars['String'];
  status: Status;
  account: Scalars['String'];
  from_currency: Currency;
  to_currency: Currency;
  from_amount: Scalars['Float'];
  to_amount: Scalars['Float'];
  exchange_rate: Scalars['Float'];
  order_date: Scalars['Time'];
  fulfillment_date?: Maybe<Scalars['Time']>;
};

export type CurrencyConversionListItem = {
  __typename?: 'CurrencyConversionListItem';
  transaction_code: Scalars['String'];
  status: Status;
  account: Scalars['String'];
  from_currency: Currency;
  to_currency: Currency;
  from_amount: Scalars['Float'];
  to_amount: Scalars['Float'];
  exchange_rate: Scalars['Float'];
  order_date: Scalars['Time'];
};

export type CurrencyConversionsResponse = {
  __typename?: 'CurrencyConversionsResponse';
  currency_conversions: Array<CurrencyConversionListItem>;
  page: Scalars['Int'];
  page_count: Scalars['Int'];
};

export enum CurrencyListType {
  All = 'all',
  OwnHistory = 'own_history',
  OwnActual = 'own_actual'
}

export enum CurrencyType {
  Transition = 'transition',
  Transfer = 'transfer',
  Conversion = 'conversion'
}

export enum DaytradeType {
  Open = 'open',
  Close = 'close'
}

export enum Direction {
  Buy = 'buy',
  Sell = 'sell'
}

export type ExchangeOrder = {
  __typename?: 'ExchangeOrder';
  id: Scalars['Int'];
  transaction_code: Scalars['String'];
  status: Status;
  direction: Direction;
  account: Scalars['String'];
  security: Security;
  count: Scalars['Int'];
  fulfilled_count: Scalars['Int'];
  daytrade: Scalars['Boolean'];
  daytrade_type?: Maybe<DaytradeType>;
  type: ExchangeRateType;
  limit_price?: Maybe<Scalars['Float']>;
  activation_price?: Maybe<Scalars['Float']>;
  outside_trading_hours: Scalars['Boolean'];
  validity_start: Scalars['Time'];
  validity_end?: Maybe<Scalars['Time']>;
  deal_price: Scalars['Float'];
  reject_reason: Scalars['String'];
  reject_reason_en: Scalars['String'];
  cancel_accepted?: Maybe<Scalars['Boolean']>;
  cancel_reject_reason: Scalars['String'];
  cancel_reject_reason_en: Scalars['String'];
};

export type ExchangeOrderListItem = {
  __typename?: 'ExchangeOrderListItem';
  id: Scalars['Int'];
  transaction_code: Scalars['String'];
  status: Status;
  direction: Direction;
  security: Security;
  count: Scalars['Int'];
  fulfilled_count: Scalars['Int'];
  type: ExchangeRateType;
  limit_price?: Maybe<Scalars['Float']>;
  activation_price?: Maybe<Scalars['Float']>;
  validity_start: Scalars['Time'];
  validity_end?: Maybe<Scalars['Time']>;
  deal_price: Scalars['Float'];
  reject_reason: Scalars['String'];
  reject_reason_en: Scalars['String'];
  cancel_accepted?: Maybe<Scalars['Boolean']>;
  cancel_reject_reason: Scalars['String'];
  cancel_reject_reason_en: Scalars['String'];
};

export type ExchangeOrdersResponse = {
  __typename?: 'ExchangeOrdersResponse';
  exchange_orders: Array<ExchangeOrderListItem>;
  page: Scalars['Int'];
  page_count: Scalars['Int'];
};

export enum ExchangeRateType {
  LimitPrice = 'limit_price',
  StopLimit = 'stop_limit',
  StopMarket = 'stop_market'
}

export type GetMessagesResult = {
  __typename?: 'GetMessagesResult';
  messages: Array<MessageListItem>;
  page: Scalars['Int'];
  page_count: Scalars['Int'];
};

export type GetNotificationsResult = {
  __typename?: 'GetNotificationsResult';
  notifications: Array<Notification>;
  page: Scalars['Int'];
  page_count: Scalars['Int'];
};

export type GraphPoint = {
  __typename?: 'GraphPoint';
  value: Scalars['Float'];
  time: Scalars['Time'];
};

export type HistoryGraph = {
  __typename?: 'HistoryGraph';
  value: Scalars['Float'];
  percent: Scalars['Float'];
  points: Array<GraphPoint>;
};

export type HistoryQuery = {
  account: Scalars['String'];
  range: Scalars['Int'];
};

export type ListingFilter = {
  account: Scalars['String'];
  status: Array<Status>;
  ids: Array<Scalars['String']>;
};

export type ListingOrder = {
  type: OrderingType;
  direction: OrderingDirection;
};

export type LoginToken = {
  __typename?: 'LoginToken';
  token: Scalars['String'];
};

export type Message = {
  __typename?: 'Message';
  id: Scalars['Int'];
  time: Scalars['Time'];
  type: Scalars['String'];
  subject: Scalars['String'];
  subject_en: Scalars['String'];
  text: Scalars['String'];
  text_en: Scalars['String'];
  awaiting_acception: Scalars['Boolean'];
  accepted: Scalars['Boolean'];
  unread: Scalars['Boolean'];
  attachments: Array<Scalars['String']>;
};

export type MessageListItem = {
  __typename?: 'MessageListItem';
  id: Scalars['Int'];
  time: Scalars['Time'];
  type: Scalars['String'];
  subject: Scalars['String'];
  subject_en: Scalars['String'];
  text: Scalars['String'];
  text_en: Scalars['String'];
  awaiting_acception: Scalars['Boolean'];
  accepted: Scalars['Boolean'];
  unread: Scalars['Boolean'];
  has_attachment: Scalars['Boolean'];
};

export type MoneyTransfer = {
  __typename?: 'MoneyTransfer';
  transaction_code: Scalars['String'];
  status: Status;
  from_account: Scalars['String'];
  to_account: Scalars['String'];
  currency: Currency;
  amount: Scalars['Float'];
  order_date: Scalars['Time'];
  fulfillment_date?: Maybe<Scalars['Time']>;
};

export type MoneyTransferListItem = {
  __typename?: 'MoneyTransferListItem';
  transaction_code: Scalars['String'];
  status: Status;
  from_account: Scalars['String'];
  currency: Currency;
  amount: Scalars['Float'];
  order_date: Scalars['Time'];
};

export type MoneyTransfersResponse = {
  __typename?: 'MoneyTransfersResponse';
  money_transfers: Array<MoneyTransferListItem>;
  page: Scalars['Int'];
  page_count: Scalars['Int'];
};

export type MoneyTransition = {
  __typename?: 'MoneyTransition';
  transaction_code: Scalars['String'];
  status: Status;
  from_account: Scalars['String'];
  to_account: Scalars['String'];
  amount: Scalars['Float'];
  currency: Scalars['String'];
  transfer_date: Scalars['Time'];
  fulfillment_date?: Maybe<Scalars['Time']>;
};

export type MoneyTransitionListItem = {
  __typename?: 'MoneyTransitionListItem';
  transaction_code: Scalars['String'];
  status: Status;
  from_account: Scalars['String'];
  to_account: Scalars['String'];
  amount: Scalars['Float'];
  currency: Scalars['String'];
  transfer_date: Scalars['Time'];
  fulfillment_date?: Maybe<Scalars['Time']>;
};

export type MoneyTransitionsResponse = {
  __typename?: 'MoneyTransitionsResponse';
  money_transitions: Array<MoneyTransitionListItem>;
  page: Scalars['Int'];
  page_count: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  update_user_password: Scalars['Boolean'];
  update_user_timeout: Scalars['Boolean'];
  update_user_password_with_confirm: UpdatePasswordToken;
  confirm_password_update: Scalars['Boolean'];
  read_notification: Scalars['Boolean'];
  read_message: Scalars['Boolean'];
  accept_message: Scalars['Boolean'];
  logout: Scalars['Boolean'];
  create_exchange_order: Scalars['String'];
  create_exchange_order_confirm: Scalars['Boolean'];
  cancel_exchange_order: Scalars['String'];
  cancel_exchange_order_confirm: Scalars['Boolean'];
  update_user_language: Scalars['Boolean'];
  accept_terms_of_use: Scalars['Boolean'];
};


export type MutationUpdate_User_PasswordArgs = {
  input: UpdateUserPassword;
};


export type MutationUpdate_User_TimeoutArgs = {
  input: Scalars['Int'];
};


export type MutationUpdate_User_Password_With_ConfirmArgs = {
  input: UpdateUserPassword;
};


export type MutationConfirm_Password_UpdateArgs = {
  input: AuthSecond;
};


export type MutationRead_NotificationArgs = {
  input: Scalars['Int'];
};


export type MutationRead_MessageArgs = {
  input: Scalars['Int'];
};


export type MutationAccept_MessageArgs = {
  input: Scalars['Int'];
};


export type MutationCreate_Exchange_OrderArgs = {
  input: CreateExchangeOrder;
};


export type MutationCreate_Exchange_Order_ConfirmArgs = {
  secret: Scalars['String'];
  token?: Maybe<Scalars['String']>;
};


export type MutationCancel_Exchange_OrderArgs = {
  id: Scalars['Int'];
};


export type MutationCancel_Exchange_Order_ConfirmArgs = {
  secret: Scalars['String'];
  token: Scalars['String'];
};


export type MutationUpdate_User_LanguageArgs = {
  input: Scalars['String'];
};


export type MutationAccept_Terms_Of_UseArgs = {
  input: Scalars['Int'];
};

export type Notification = {
  __typename?: 'Notification';
  id: Scalars['Int'];
  time: Scalars['Time'];
  text: Scalars['String'];
  text_en: Scalars['String'];
  direction?: Maybe<Direction>;
  unread: Scalars['Boolean'];
};

export enum OrderingDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum OrderingType {
  None = 'none',
  Status = 'status',
  TransactionCode = 'transaction_code',
  Security = 'security',
  Direction = 'direction',
  Count = 'count',
  LimitPrice = 'limit_price',
  ActivationPrice = 'activation_price',
  Value = 'value',
  ValidityStart = 'validity_start',
  ValidityEnd = 'validity_end',
  FromAccount = 'from_account',
  ToAccount = 'to_account',
  Currency = 'currency',
  TransferDate = 'transfer_date',
  TransitionDate = 'transition_date',
  OrderDate = 'order_date',
  FromAmount = 'from_amount',
  ToAmount = 'to_amount',
  FromValue = 'from_value',
  ToValue = 'to_value'
}

export type Paginator = {
  page: Scalars['Int'];
  per_page: Scalars['Int'];
};

export type PersonalContract = {
  __typename?: 'PersonalContract';
  id: Scalars['Int'];
  time: Scalars['Time'];
  name: Scalars['String'];
  name_en: Scalars['String'];
  attachment: Scalars['String'];
  attachment_en: Scalars['String'];
};

export type PersonalDocument = {
  __typename?: 'PersonalDocument';
  type: Scalars['String'];
  type_en: Scalars['String'];
  number: Scalars['String'];
  expiry: Scalars['Time'];
};

export type Portfolio = {
  __typename?: 'Portfolio';
  last_update: Scalars['Time'];
  sum: Scalars['Float'];
  portfolio: Array<Slice>;
};

export type PortfolioFinancialInstrument = PortfolioFundamental & {
  __typename?: 'PortfolioFinancialInstrument';
  name: Scalars['String'];
  count: Scalars['Int'];
  reserved: Scalars['Float'];
  investable: Scalars['Float'];
  payable: Scalars['Float'];
  last_closing_price: Scalars['Float'];
  market_price: Scalars['Float'];
  exchange_rate: Scalars['Float'];
  value: Scalars['Float'];
  percent: Scalars['Float'];
  accounts: Array<Account>;
  security: Security;
  security_type: SecurityType;
  tradable_stock_exchange: Scalars['Boolean'];
  type: Scalars['String'];
};

export type PortfolioFundamental = {
  name: Scalars['String'];
  reserved: Scalars['Float'];
  investable: Scalars['Float'];
  payable: Scalars['Float'];
  market_price: Scalars['Float'];
  exchange_rate: Scalars['Float'];
  value: Scalars['Float'];
  percent: Scalars['Float'];
  accounts: Array<Account>;
};

export type PortfolioFunds = PortfolioFundamental & {
  __typename?: 'PortfolioFunds';
  name: Scalars['String'];
  balance: Scalars['Float'];
  reserved: Scalars['Float'];
  investable: Scalars['Float'];
  payable: Scalars['Float'];
  market_price: Scalars['Float'];
  exchange_rate: Scalars['Float'];
  value: Scalars['Float'];
  percent: Scalars['Float'];
  accounts: Array<Account>;
};

export type Query = {
  __typename?: 'Query';
  login_first: LoginToken;
  login_second: AuthToken;
  validate_password: Scalars['Boolean'];
  token_validate: AuthToken;
  getUser?: Maybe<User>;
  getAcceptedTermsOfUse: Array<AcceptedTermOfUse>;
  get_unread_notifications_count: Scalars['Int'];
  get_notifications: GetNotificationsResult;
  get_unread_messages_count: Scalars['Int'];
  get_messages: GetMessagesResult;
  get_message: Message;
  sum_portfolio: Portfolio;
  portfolio_history_graph: HistoryGraph;
  portfolio_fundamentals: Array<PortfolioFundamental>;
  get_exchange_order: ExchangeOrder;
  get_exchange_orders: ExchangeOrdersResponse;
  get_securities: Array<Security>;
  get_account_balance: AccountBalance;
  get_security_amount: AccountBalance;
  get_valid_trading_days: Array<Scalars['Time']>;
  get_unit_order: UnitOrder;
  get_unit_orders: UnitOrdersResponse;
  get_money_transition: MoneyTransition;
  get_money_transitions: MoneyTransitionsResponse;
  get_currencies: Array<Currency>;
  get_security_transition: SecurityTransition;
  get_security_transitions: SecurityTransitionsResponse;
  get_currency_conversion: CurrencyConversion;
  get_currency_conversions: CurrencyConversionsResponse;
  get_security_transfer: SecurityTransfer;
  get_security_transfers: SecurityTransfersResponse;
  get_money_transfer: MoneyTransfer;
  get_money_transfers: MoneyTransfersResponse;
};


export type QueryLogin_FirstArgs = {
  input: AuthFirst;
};


export type QueryLogin_SecondArgs = {
  input: AuthSecond;
};


export type QueryValidate_PasswordArgs = {
  old_password: Scalars['String'];
};


export type QueryGet_NotificationsArgs = {
  paginator: Paginator;
};


export type QueryGet_MessagesArgs = {
  paginator: Paginator;
};


export type QueryGet_MessageArgs = {
  id: Scalars['Int'];
};


export type QueryPortfolio_History_GraphArgs = {
  input: HistoryQuery;
};


export type QueryPortfolio_FundamentalsArgs = {
  account: Scalars['String'];
};


export type QueryGet_Exchange_OrderArgs = {
  id: Scalars['Int'];
};


export type QueryGet_Exchange_OrdersArgs = {
  paginator: Paginator;
  order: ListingOrder;
  filter: ListingFilter;
};


export type QueryGet_SecuritiesArgs = {
  type: SecurityType;
  list_type: SecurityListType;
  account: Scalars['String'];
};


export type QueryGet_Account_BalanceArgs = {
  account: Scalars['String'];
  currency: Scalars['String'];
};


export type QueryGet_Security_AmountArgs = {
  account: Scalars['String'];
  security: Scalars['String'];
};


export type QueryGet_Unit_OrderArgs = {
  id: Scalars['String'];
};


export type QueryGet_Unit_OrdersArgs = {
  paginator: Paginator;
  order: ListingOrder;
  filter: ListingFilter;
};


export type QueryGet_Money_TransitionArgs = {
  id: Scalars['String'];
};


export type QueryGet_Money_TransitionsArgs = {
  paginator: Paginator;
  order: ListingOrder;
  filter: ListingFilter;
};


export type QueryGet_CurrenciesArgs = {
  type: CurrencyType;
  list_type: CurrencyListType;
  account: Scalars['String'];
};


export type QueryGet_Security_TransitionArgs = {
  id: Scalars['String'];
};


export type QueryGet_Security_TransitionsArgs = {
  paginator: Paginator;
  order: ListingOrder;
  filter: ListingFilter;
};


export type QueryGet_Currency_ConversionArgs = {
  id: Scalars['String'];
};


export type QueryGet_Currency_ConversionsArgs = {
  paginator: Paginator;
  order: ListingOrder;
  filter: ListingFilter;
};


export type QueryGet_Security_TransferArgs = {
  id: Scalars['String'];
};


export type QueryGet_Security_TransfersArgs = {
  paginator: Paginator;
  order: ListingOrder;
  filter: ListingFilter;
};


export type QueryGet_Money_TransferArgs = {
  id: Scalars['String'];
};


export type QueryGet_Money_TransfersArgs = {
  paginator: Paginator;
  order: ListingOrder;
  filter: ListingFilter;
};

export type Security = {
  __typename?: 'Security';
  short_name: Scalars['String'];
  name: Scalars['String'];
  stock_market_locality: Scalars['String'];
  currency: Currency;
};

export enum SecurityListType {
  All = 'all',
  OwnHistory = 'own_history',
  OwnActual = 'own_actual'
}

export type SecurityTransfer = {
  __typename?: 'SecurityTransfer';
  transaction_code: Scalars['String'];
  status: Status;
  account: Scalars['String'];
  to_provider: Scalars['String'];
  security: Security;
  amount: Scalars['Int'];
  order_date: Scalars['Time'];
  fulfillment_date?: Maybe<Scalars['Time']>;
};

export type SecurityTransferListItem = {
  __typename?: 'SecurityTransferListItem';
  transaction_code: Scalars['String'];
  status: Status;
  account: Scalars['String'];
  security: Security;
  amount: Scalars['Int'];
  order_date: Scalars['Time'];
};

export type SecurityTransfersResponse = {
  __typename?: 'SecurityTransfersResponse';
  security_transfers: Array<SecurityTransferListItem>;
  page: Scalars['Int'];
  page_count: Scalars['Int'];
};

export type SecurityTransition = {
  __typename?: 'SecurityTransition';
  transaction_code: Scalars['String'];
  status: Status;
  from_account: Scalars['String'];
  to_account: Scalars['String'];
  amount: Scalars['Int'];
  security: Security;
  transfer_date: Scalars['Time'];
  fulfillment_date?: Maybe<Scalars['Time']>;
};

export type SecurityTransitionListItem = {
  __typename?: 'SecurityTransitionListItem';
  transaction_code: Scalars['String'];
  status: Status;
  from_account: Scalars['String'];
  to_account: Scalars['String'];
  amount: Scalars['Int'];
  security: Security;
  transfer_date: Scalars['Time'];
  fulfillment_date?: Maybe<Scalars['Time']>;
};

export type SecurityTransitionsResponse = {
  __typename?: 'SecurityTransitionsResponse';
  security_transitions: Array<SecurityTransitionListItem>;
  page: Scalars['Int'];
  page_count: Scalars['Int'];
};

export enum SecurityType {
  ExchangeOrder = 'exchange_order',
  UnitOrder = 'unit_order',
  Transition = 'transition',
  Transfer = 'transfer'
}

export type Slice = {
  __typename?: 'Slice';
  name: Scalars['String'];
  value: Scalars['Float'];
  percent: Scalars['Float'];
};

export enum Status {
  Active = 'active',
  Expired = 'expired',
  Pending = 'pending',
  Partial = 'partial',
  CancelRequested = 'cancel_requested',
  Canceled = 'canceled',
  Completed = 'completed',
  Rejected = 'rejected'
}

export type Subscription = {
  __typename?: 'Subscription';
  test: Scalars['Boolean'];
  new_token: AuthToken;
  notification_unread_count: Scalars['Int'];
  notification_read: Scalars['Int'];
  new_notification: Notification;
  auto_read_notification: Scalars['Boolean'];
  new_message: MessageListItem;
  message_unread_count: Scalars['Int'];
  message_read: Scalars['Int'];
  sum_portfolio: Portfolio;
  new_exchange_order: ExchangeOrderListItem;
  update_exchange_order: ExchangeOrderListItem;
  new_unit_order: UnitOrderListItem;
  update_unit_order: UnitOrderListItem;
  new_money_transition: MoneyTransitionListItem;
  update_money_transition: MoneyTransitionListItem;
  new_security_transition: SecurityTransitionListItem;
  update_security_transition: SecurityTransitionListItem;
  new_currency_conversion: CurrencyConversionListItem;
  update_currency_conversion: CurrencyConversionListItem;
  new_security_transfer: SecurityTransferListItem;
  update_security_transfer: SecurityTransferListItem;
  new_money_transfer: MoneyTransferListItem;
  update_money_transfer: MoneyTransferListItem;
};

export type TermsAndConditions = {
  __typename?: 'TermsAndConditions';
  id: Scalars['Int'];
  time: Scalars['Time'];
  name: Scalars['String'];
  name_en: Scalars['String'];
  attachment: Scalars['String'];
  attachment_en: Scalars['String'];
};

export type TermsOfUse = {
  __typename?: 'TermsOfUse';
  id: Scalars['Int'];
  document: Scalars['String'];
  document_en: Scalars['String'];
};


export type UnitOrder = {
  __typename?: 'UnitOrder';
  transaction_code: Scalars['String'];
  status: Status;
  direction: Direction;
  account: Scalars['String'];
  security: Security;
  count: Scalars['Int'];
  fulfilled_count: Scalars['Int'];
  last_available_net_price: Scalars['Float'];
  validity_start: Scalars['Time'];
  validity_end: Scalars['Time'];
  deal_price: Scalars['Float'];
  purchase_value: Scalars['Float'];
};

export type UnitOrderListItem = {
  __typename?: 'UnitOrderListItem';
  transaction_code: Scalars['String'];
  status: Status;
  direction: Direction;
  security: Security;
  count: Scalars['Int'];
  fulfilled_count: Scalars['Int'];
  validity_start: Scalars['Time'];
  validity_end: Scalars['Time'];
  deal_price: Scalars['Float'];
  purchase_value: Scalars['Float'];
};

export type UnitOrdersResponse = {
  __typename?: 'UnitOrdersResponse';
  unit_orders: Array<UnitOrderListItem>;
  page: Scalars['Int'];
  page_count: Scalars['Int'];
};

export type UpdatePasswordToken = {
  __typename?: 'UpdatePasswordToken';
  token: Scalars['String'];
};

export type UpdateUserPassword = {
  old_password: Scalars['String'];
  new_password: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  uid: Scalars['String'];
  kommpId: Scalars['String'];
  brokers: Array<Broker>;
  name: Scalars['String'];
  accounts: Array<Account>;
  need_transaction_second_confirmation: Scalars['Boolean'];
  phone: Scalars['String'];
  tax_number: Scalars['String'];
  email: Scalars['String'];
  mailing_address: Address;
  billing_address: Address;
  place_of_birth: Scalars['String'];
  time_of_birth?: Maybe<Scalars['Time']>;
  mothers_name: Scalars['String'];
  personal_documents: Array<PersonalDocument>;
  is_company: Scalars['Boolean'];
  registration_number: Scalars['String'];
  company_name: Scalars['String'];
  language: Scalars['String'];
  terms_and_conditions: Array<TermsAndConditions>;
  personal_contracts: Array<PersonalContract>;
};
